import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';
import { MatIconRegistry, MAT_DATE_LOCALE } from '@angular/material';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TextMaskModule } from 'angular2-text-mask';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PortalReportModule } from './reports/portal-report.module';
import { ExplainPlanDialogComponent } from './reports/components/entity/explain-plan-dialog/explain-plan-dialog.component';
import {
  RteMaterialModule,
  RteLibraryModule,
  RteToolbarModule,
  RteTabModule,
  RteAutoCompleteModule,
  YesNoDialogComponent,
  AppService,
  CookieService,
  AppHttpInterceptor,
  TabComponent,
  RteMaterialBaseService,
  RteDialog,
  RTE_APP_SERVICE_DATA,
  RTE_COOKIE_SERVICE_DATA,
  APP_MAIN_URL,
  RteColorService,
  RTE_COLOR_SERVICE_DATA
} from 'rte-library';
import {
  RteLoginModule,
  RteUserModule,
  RteSearchApplicationModule,
  RteAssemblyRegisterModule,
  DialogPasswordComponent,
  RteMenuModule,
  RTE_MENU_SERVICE_DATA
} from 'rte-core-app';
import { BottomSheetDownloadOptionsComponent } from './reports/components/report-view/report-render/report-exportation/bottom-sheet-download-options/bottom-sheet-download-options.component';
import { environment } from 'src/environments/environment';
import { MenuService } from './service/menu.service';
import { QueryResultDialogComponent } from './reports/components/entity/query-result-dialog/query-result-dialog.component';
import { AppConfigService } from './app-config.service';
import { BaseShareDialogComponent } from './reports/shared/share-dialog/base-share-dialog/base-share-dialog.component';
import { ReportErrorExportDialogComponent } from './reports/components/report-view/report-render/report-error-export-dialog/report-error-export-dialog.component';

  @NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FlexLayoutModule,
    PortalReportModule,

    TextMaskModule,
    RteMenuModule,
    RteTabModule,
    RteToolbarModule,
    RteAutoCompleteModule,
    RteMaterialModule,
    RteLibraryModule,
    RteSearchApplicationModule,
    RteAssemblyRegisterModule,
    RteLoginModule.forRoot(environment),
    RteUserModule.forRoot(environment)
  ],
  entryComponents: [
    YesNoDialogComponent,
    DialogPasswordComponent,
    QueryResultDialogComponent,
    ExplainPlanDialogComponent,
    BottomSheetDownloadOptionsComponent,
    BaseShareDialogComponent,
    ReportErrorExportDialogComponent,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          return appConfigService.loadAppConfig();
        };
      }
    },
    { provide: APP_MAIN_URL, useFactory() { return environment.apiUrl }},
    { provide: RTE_APP_SERVICE_DATA, useExisting: AppService },
    { provide: RTE_COOKIE_SERVICE_DATA, useExisting: CookieService },
    { provide: RTE_MENU_SERVICE_DATA, useClass: MenuService },
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true},
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
    { provide: RteMaterialBaseService, useExisting: AppService },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    { provide: RTE_COLOR_SERVICE_DATA, useClass: RteColorService},
    TabComponent,
    RteDialog,
    MatIconRegistry
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    public matIconRegistry: MatIconRegistry) {
    matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
  }
}
